/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import { useState, useEffect } from 'react';

function useStickyState(defaultValue, key) {
    var _a = useState(function () {
        var stickyValue = window.localStorage.getItem(key);
        return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    }), value = _a[0], setValue = _a[1];
    useEffect(function () {
        window.localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
    return [value, setValue];
}

export { useStickyState as default };
